module.exports = __webpack_public_path__ + "img/home_banner_web_BG5.b17c3854.png";